import { ILoggerSettings } from '@1js/search-logger/dist/amd/lib/logger.settings';
import { Injectable } from '@angular/core';

import { SearchConfigService } from '../search-results/services/search-config.service';

@Injectable({ providedIn: 'root' })
export class FastSearchUXLoggerSettingsService {

    constructor(
        private readonly searchConfigService: SearchConfigService) {}

    public createSettings(): ILoggerSettings {
        const {
            fastShowPersonalResultsEnabled
        } = this.searchConfigService.config;

        return {
            'searchux.clientSideRelevance': true,
            'searchux.isCrossGeoEnabled': true,
            'searchux.isResourceLoggingEnabled': true,
            'searchux.showPersonalResults': fastShowPersonalResultsEnabled,
            'searchux.useSearchApp': false,
            'searchux.use3SFileSuggestions': true,
            'searchux.use3SPeopleSuggestions': true,
            'searchux.use3SSiteSuggestions': true,
            'searchux.useSearchBoxInTheSuiteNav': this.searchConfigService.config.searchInHeaderEnabled
        };
    }
}
